import { render, staticRenderFns } from "./StatisticInfoCard.vue?vue&type=template&id=05b319f3"
import script from "./StatisticInfoCard.vue?vue&type=script&lang=js"
export * from "./StatisticInfoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports